export const headerFallbackRu = {
  id: 1,
  mobileMenuTitle: 'Меню',
  locale: 'ru',
  anchorLinks: [
    {id: 1, title: 'Возможности платформы', href: '#opportunities'},
    {id: 2, title: 'Инструменты', href: '#tools'},
    {id: 3, title: 'Как опубликовать приложение', href: '#publish'},
    {id: 4, title: 'Стать амбассадором', href: '#ambassador'},
    {id: 5, title: 'F.A.Q.', href: '#FAQ'},
  ],
  redesignDevAnchorLinks: [
    {id: 1, title: 'Возможности', href: '#opportunities'},
    {id: 2, title: 'Инструменты', href: '#tools'},
    {id: 3, title: 'Как опубликовать приложение', href: '#publish'},
    {id: 5, title: 'Продвижение', href: '#advancement'},
    {id: 5, title: 'Вопросы и ответы', href: '#FAQ'},
    {id: 5, title: 'Блог', href: '#blog'},
    {id: 5, title: 'Обновления', href: '#update'},
  ],
  links: [
    {
      id: '2',
      title: 'Приложения',
      href: 'https://www.rustore.ru/catalog',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_apps_0b6e17b76b.svg',
      },
      isTargetBlank: false,
    },
    {
      id: '4',
      title: 'Игры',
      href: 'https://www.rustore.ru/catalog/games',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_games_23d3993d7d.svg',
      },
      isTargetBlank: false,
    },
    {
      id: '3',
      title: 'Разработчикам',
      href: 'https://www.rustore.ru/developer',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_developers_41836cc41f.svg',
      },
      isTargetBlank: true,
    },
    {
      id: '1',
      title: 'Помощь',
      href: 'https://www.rustore.ru/help',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_help_648c698556.svg',
      },
      isTargetBlank: true,
    },
  ],
  logo: {
    id: 1,
    logoHref: {
      id: 997,
      width: 144,
      height: 36,
      url: 'https://static.rustore.ru/rustore-strapi/9/logo_color_30_px_2_fa2039288f_79e6d8ec78.svg',
    },
    afterLogoImageHref: {
      id: 996,
      width: 104,
      height: 30,
      url: 'https://static.rustore.ru/rustore-strapi/6/Logo_3_3ca73f3115.svg',
    },
  },
  searchButtonText: 'Поиск',
  downloadButtonText: 'Скачать RuStore',
  toolsAnchorLinks: [
    {
      id: 1,
      title: 'Список инструментов',
      href: '#toolsList',
    },
    {
      id: 2,
      title: 'Лёгкий старт',
      href: '#quickStart',
    },
    {
      id: 3,
      title: 'Преимущества',
      href: '#advantages',
    },
    {
      id: 4,
      title: 'Документация',
      href: '#documentation',
    },
    {
      id: 5,
      title: 'Вопросы и ответы',
      href: '#FAQ',
    },
  ],
};

export const headerFallbackEn = {
  mobileMenuTitle: 'Menu',
  anchorLinks: [
    {
      id: 12,
      title: 'Features',
      href: '#opportunities',
    },
    {
      id: 9,
      title: 'Tools',
      href: '#tools',
    },
    {
      id: 7,
      title: 'How to publish an app',
      href: '#publish',
    },
    {
      id: 11,
      title: 'Become Ambassador',
      href: '#ambassador',
    },
    {
      id: 8,
      title: 'F.A.Q.',
      href: '#FAQ',
    },
  ],
  redesignDevAnchorLinks: [
    {
      id: 12,
      title: 'Features',
      href: '#opportunities',
    },
    {
      id: 9,
      title: 'Tools',
      href: '#tools',
    },
    {
      id: 7,
      title: 'How to publish an app',
      href: '#publish',
    },
    {
      id: 10,
      title: 'Promotion',
      href: '#advancement',
    },
    {
      id: 8,
      title: 'FAQ',
      href: '#FAQ',
    },
    {
      id: 11,
      title: 'Blog',
      href: '#blog',
    },
    {
      id: 13,
      title: 'Updates',
      href: '#update',
    },
  ],
  links: [
    {
      id: '8',
      title: 'Apps',
      href: 'https://www.rustore.ru/catalog',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_apps_0b6e17b76b.svg',
      },
      isTargetBlank: true,
    },
    {
      id: '7',
      title: 'Games',
      href: 'https://www.rustore.ru/catalog/games',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_games_23d3993d7d.svg',
      },
      isTargetBlank: true,
    },
    {
      id: '6',
      title: 'Developers',
      href: 'https://www.rustore.ru/developer/en',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_developers_41836cc41f.svg',
      },
      isTargetBlank: true,
    },
    {
      id: '5',
      title: 'Help',
      href: 'https://www.rustore.ru/help/en',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_help_648c698556.svg',
      },
      isTargetBlank: true,
    },
  ],
  logo: {
    id: 1,
    logoHref: {
      id: 320,
      url: 'https://static.rustore.ru/rustore-strapi/9/logo_color_30_px_2_fa2039288f_79e6d8ec78.svg',
    },
    afterLogoImageHref: {
      id: 321,
      url: 'https://static.rustore.ru/rustore-strapi/6/Eng_After_Logo_7e6b682866.svg',
    },
  },
  searchButtonText: 'Search',
  downloadButtonText: 'Download RuStore',
  toolsAnchorLinks: [
    {
      id: 1,
      title: 'Tools list',
      href: '#toolsList',
    },
    {
      id: 2,
      title: 'Quick Start',
      href: '#quickStart',
    },
    {
      id: 3,
      title: 'Advantages',
      href: '#advantages',
    },
    {
      id: 4,
      title: 'Documentation',
      href: '#documentation',
    },
    {
      id: 5,
      title: 'F.A.Q.',
      href: '#FAQ',
    },
  ],
};
export const headerFallbackZh = {
  mobileMenuTitle: '菜单',
  anchorLinks: [
    {
      id: 13,
      title: '平台功能',
      href: '#opportunities',
    },
    {
      id: 15,
      title: '工具',
      href: '#tools',
    },
    {
      id: 16,
      title: '发布应用指南',
      href: '#publish',
    },
    {
      id: 18,
      title: '常见问题',
      href: '#FAQ',
    },
  ],
  redesignDevAnchorLinks: [
    {
      id: 14,
      title: '平台功能',
      href: '#opportunities',
    },
    {
      id: 15,
      title: '工具',
      href: '#tools',
    },
    {
      id: 16,
      title: '发布应用指南',
      href: '#publish',
    },
    {
      id: 17,
      title: '推广',
      href: '#advancement',
    },
    {
      id: 18,
      title: '常见问题',
      href: '#FAQ',
    },
    {
      id: 19,
      title: '博客',
      href: '#blog',
    },
    {
      id: 20,
      title: '更新',
      href: '#update',
    },
  ],
  links: [
    {
      id: '10',
      title: '应用',
      href: 'https://www.rustore.ru/catalog',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_apps_0b6e17b76b.svg',
      },
      isTargetBlank: true,
    },
    {
      id: '9',
      title: '游戏',
      href: 'https://www.rustore.ru/catalog/games',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_games_23d3993d7d.svg',
      },
      isTargetBlank: true,
    },
    {
      id: '12',
      title: '为开发者',
      href: 'https://www.rustore.ru/developer/zh',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_developers_41836cc41f.svg',
      },
      isTargetBlank: true,
    },
    {
      id: '11',
      title: '技术手册',
      href: 'https://www.rustore.ru/help/zh',
      mobileIcon: {
        url: 'https://static.rustore.ru/rustore-strapi/7/ic_help_648c698556.svg',
      },
      isTargetBlank: true,
    },
  ],
  logo: {
    id: 1,
    logoHref: {
      id: 320,
      url: 'https://static.rustore.ru/rustore-strapi/9/logo_color_30_px_2_fa2039288f_79e6d8ec78.svg',
    },
    afterLogoImageHref: {
      id: 321,
      url: 'https://static.rustore.ru/rustore-strapi/6/Eng_After_Logo_7e6b682866.svg',
    },
  },
  searchButtonText: '搜索',
  downloadButtonText: '下载RuStore',
  toolsAnchorLinks: [
    {
      id: 1,
      title: '工具清单',
      href: '#toolsList',
    },
    {
      id: 2,
      title: '快速入门',
      href: '#quickStart',
    },
    {
      id: 3,
      title: '优点',
      href: '#advantages',
    },
    {
      id: 4,
      title: '文档',
      href: '#documentation',
    },
    {
      id: 5,
      title: '技术手册',
      href: '#FAQ',
    },
  ],
};
